import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import APP_ROUTER from 'router/appRouter';
import { EnumAppRouter } from 'router/enum';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {APP_ROUTER.map((v, i) => (
          <Route key={v.url + String(i)} path={v.url} element={v.component} />
        ))}
        <Route path="/*" element={<Navigate to={EnumAppRouter.登入} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
